"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _cnbuilder = require("cnbuilder");
var _app = require("../Context/app");
var _TDHLightMode = _interopRequireDefault(require("../Loader/icons/TDH-light-mode.svg"));
var _TDHDarkMode = _interopRequireDefault(require("../Loader/icons/TDH-dark-mode.svg"));
var _LoaderModule = _interopRequireDefault(require("../Loader/Loader.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const Loader = _ref => {
  let {
    inline,
    size,
    loadingText
  } = _ref;
  const withLoaderText = loadingText && size === 'large';
  const appContext = (0, _app.useAppContext)();
  (0, _react.useEffect)(() => {
    if (loadingText && loadingText.length > 110) {
      throw new Error('Loading text is limited to 110 characters!');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _cnbuilder.cnb)(_LoaderModule.default.root, {
      [_LoaderModule.default.inline]: inline
    }, {
      [_LoaderModule.default.medium]: size === 'medium'
    }, {
      [_LoaderModule.default.small]: size === 'small'
    }, {
      [_LoaderModule.default['with-loader-text']]: withLoaderText
    }),
    role: "alert",
    children: [appContext && appContext.appTheme === 'teladoc' ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _cnbuilder.cnb)(_LoaderModule.default.container, _LoaderModule.default.TDHIcon),
      children: appContext.appMode === 'light' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_TDHLightMode.default, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_TDHDarkMode.default, {})
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _LoaderModule.default.container,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _LoaderModule.default.track
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _LoaderModule.default.quarter
      })]
    }), withLoaderText && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _cnbuilder.cnb)(_LoaderModule.default['loader-text']),
      "data-testid": "app-loader-text",
      children: loadingText
    })]
  });
};
Loader.defaultProps = {
  size: 'large'
};
var _default = exports.default = Loader;